export const dayNames = [
  "יום ראשון",
  "יום שני",
  "יום שלישי",
  "יום רביעי",
  "יום חמישי",
  "יום שישי",
  "יום שבת",
]

export function isBlank(value: unknown) {
  return value === null || value === undefined || value === ""
}
